const BASE = process.env.REACT_APP_API_BASE || "http://127.0.0.1:8000";

export async function getSubpages() {
  const res = await fetch(`${BASE}/api/subpages/`);
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  return res.json();
}

export async function getInfoBoxesForPage(pageName) {
  const data = await getSubpages();
  const page = Array.isArray(data) ? data.find(p => p.pageName === pageName) : null;
  return page?.info_boxes || [];
}
